module.exports = __webpack_public_path__ + "static/media/why_middle.e8aa1afd.jpg";